export default __webpack_public_path__ + "img/dIrcUWLo.16ebd707.svg";